import { MessageBarType } from '@fluentui/react';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app.store';

export interface Notification {
  id: string; // unique id for each notification
  message?: string;
  messageBarType?: MessageBarType;
  show: boolean;
}

export type NotificationState = Notification[];

const initialState: NotificationState = [];

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    RA_ADD_NOTIFICATION: (state, action: PayloadAction<Notification>) => {
      state.push({ ...action.payload });
    },
    RA_REMOVE_NOTIFICATION: (state, action: PayloadAction<string>) => {
      // Remove notification by id
      return state.filter(notification => notification.id !== action.payload);
    },
    RA_CLEAR_ALL_NOTIFICATIONS: () => {
      return [];
    },
  },
});

export const { RA_ADD_NOTIFICATION, RA_REMOVE_NOTIFICATION, RA_CLEAR_ALL_NOTIFICATIONS } = notificationSlice.actions;

export const notificationsSelector = (state: RootState): NotificationState => state.notification;

export default notificationSlice.reducer;